module.exports = __webpack_public_path__ + "img/EXMO.6929c2ba.svg";